
import React from 'react';
import { Link } from 'react-router-dom';


const StorySection: React.FC = () => {
  return (
    <section className="py-24 md:py-32 bg-brand-offwhite" id="notre-histoire">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="space-y-8 max-w-lg">
            <span className="text-[11px] uppercase tracking-[0.4em] text-brand-gold font-bold">
              Notre Expertise
            </span>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight">
              Curateurs de <span className="italic">Pièces Rares</span>
            </h2>
            <p className="text-brand-black/70 leading-relaxed font-light text-lg">
              Khamal Bags s'impose comme la référence en matière de revente d'exception. Nous ne nous contentons pas de vendre des accessoires ; nous sélectionnons avec une rigueur absolue les modèles les plus iconiques de maisons telles que Polène et Coach pour vous offrir le meilleur de la maroquinerie mondiale.
            </p>
            <p className="text-brand-black/70 leading-relaxed font-light">
              Notre mission est de rendre accessible l'élégance intemporelle. En tant que revendeurs experts, nous garantissons l'authenticité de chaque pièce et une disponibilité immédiate pour nos clients les plus exigeants. Khamal Bags est le trait d'union entre vous et l'excellence artisanale.
            </p>
            <div>
              <Link 
              to="/shop" 
              className="text-[11px] uppercase tracking-[0.3em] font-bold border-b-2 border-brand-gold pb-2 hover:text-brand-gold transition-colors">
                Voir notre sélection exclusive
              </Link>
            </div>
          </div>
          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden">
              <img 
                src="https://lltsrtityvwsvhbkzdll.supabase.co/storage/v1/object/sign/images/khamalbag.jpeg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9jZjZkNmYxNS02MDgzLTQwOWQtOTI0ZC03YjhjODQxOWUwNDMiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMva2hhbWFsYmFnLmpwZWciLCJpYXQiOjE3Njg5MjUzNTksImV4cCI6MTgzMTk5NzM1OX0.qac0hos_cVHuxuFObgVOK9G7nAu_KB0xuWcKwsZhsTQ"
                alt="Sélection expert Khamal Bags"
                className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-1000"
              />
            </div>
            <div className="absolute -bottom-8 -left-8 md:-bottom-12 md:-left-12 bg-white p-8 hidden sm:block shadow-xl">
              <div className="border border-brand-gold/20 p-6 flex flex-col items-center">
                <span className="font-serif text-4xl italic text-brand-gold mb-1">Expertise</span>
                <span className="text-[10px] uppercase tracking-widest text-brand-black">Revendeur Certifié</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
